import ApiClient from '@/api/ApiClient';
import Tag from '@/api/models/Tag';

class CourseTagService {
    #prefixUrl = 'api/course_tag/';

    constructor() {
        this.api = new ApiClient(this.#prefixUrl);
    }

    /**
     * Get tags
     * @returns {Array}
     */
    async all(onlyUsed = true) {
        const response = await this.api.executeRequest(`/index`, {only_used: onlyUsed}, this.api.methods.GET);
        
        let tags = [];
        if (response.success()) {
            for (let courseData of response.getContent()) {
                tags.push(new Tag(courseData));
            }
        }
        
        return tags;
    }
}

export default new CourseTagService();
